import styled from '@emotion/styled';
import { Alert, Button, Divider, Snackbar } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import ExtensionTable from '../../components/tables/1000/ExtensionTable'
const ToolBar=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'flex-end',
    width:'100%',
    gap:'15px',
    margin:'10px 5px'

}))
const Wrapper=styled(Box)(({theme})=>({
    display:'flex',
    flexDirection:'column',
    width:'100%',
    gap:'15px',
    margin:'10px 5px'

}))
export default function ExtensionOffice() {
  const navigate=useNavigate()
  const {state}=useLocation()
  const [open,setOpen]=useState(state===null?false:true)
  const options = {
    filterType: 'multiselect',
    selectableRows:'single',
    rowsPerPage:5,
    rowsPerPageOptions:[5,10,20,40],
    rowHover:false,
    selectableRowsOnClick:true,
    // responsive:'scroll',
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) => {
            const sendData=displayData.filter((value)=>value.dataIndex===selectedRows.data[0].dataIndex)
            const status=sendData[0].data[7];
            const id=sendData[0].data[0];
            const email=sendData[0].data[1];
            const request_year=sendData[0].data[4];
            const request_semester=sendData[0].data[5];
            return(status==="Unsigned"?
                    <ToolBar>
                    <Button variant="outlined"
                    color='secondary'
                    onClick={()=>navigate('/office_approval/extensionsOffice/agreement',{state:{doc_id:id,rejected:false, view:false,request_semester,request_year,email}})}
                    >Approve the Agreement</Button>  
                    </ToolBar>:status==="Signed"?
                    <ToolBar>
                    <Button variant="outlined"
                    color='secondary'
                    onClick={()=>navigate('/office_approval/extensionsOffice/agreement',{state:{doc_id:id,rejected:false, view:true,request_semester,request_year,email}})}
                    >View Agreement Form</Button>
                    <Button variant="outlined"
                    color='third'
                    onClick={()=>navigate('/office_approval/extensionsOffice/agreement')}
                    >Print</Button>   
                </ToolBar>:
                <ToolBar>
                    <Button variant="outlined"
                    color='secondary'
                    onClick={()=>navigate('/office_approval/extensionsOffice/agreement',{state:{doc_id:id,rejected:true, view:true,request_semester,request_year,email}})}
                    >View Agreement Form</Button>
                    <Button variant="outlined"
                    color='third'
                    onClick={()=>navigate('/office_approval/extensionsOffice/agreement')}
                    >Print</Button>   
                </ToolBar>
              )}
};
  return (
    <Wrapper>
      <ExtensionTable
      option={options}
      title="Extension Agreement Forms"
      id={state!==null?state.id:false}
      />
      <Divider/>
      <Snackbar open={open} autoHideDuration={6000} onClose={()=>setOpen(false)}>
            <Alert severity="success">{state?.message} </Alert>
        </Snackbar>
    </Wrapper>
  )
}
